import setup from './moduleSetup';

export default {
    name: 'users',
    before: [],
    after: [],
    setup,
};
